import { $sheet } from './SheetView';
import { $highlight } from './selection';
import { useStore } from '@nanostores/react';
import { atom, computed } from 'nanostores';

export const $highlightTable = computed(
  [$highlight, $sheet],
  (highlight, sheet) => {
    if (!sheet) return null;
    return sheet.getTableAt(highlight);
  },
);

export function useHighlightedTable() {
  const sheet = useStore($sheet);
  const highlight = useStore($highlight);
  return useStore(sheet?.tableStoreAt(highlight) ?? atom(null));
}

export function useHighlightedRenderedCell() {
  const sheet = useStore($sheet);
  const highlight = useStore($highlight);
  return useStore(sheet?.cellStore(highlight) ?? atom(null));
}
